import { useTableContext } from "@caprikorn/dynamo-ui";
import { type FC, useEffect } from "react";

import type { AuthorizationsTableInitialSelectionProps } from "./AuthorizationsTableInitialSelection.types";

export const AuthorizationsTableInitialSelection: FC<
  AuthorizationsTableInitialSelectionProps
> = ({ initialSelectedState }) => {
  const { tableInstance } = useTableContext();
  useEffect(() => {
    if (!initialSelectedState?.length) return;

    tableInstance.resetRowSelection();

    initialSelectedState.forEach((customer) => {
      try {
        const row = tableInstance.getRow(customer.customerId);
        row?.toggleSelected(true);
      } catch (e) {
        console.warn(`${e} - ${customer.customerId}`);
      }
    });
  }, [initialSelectedState, tableInstance]);

  return null;
};
